import { PageHeader } from "@/components/PageHeader";
import { Card } from "@/components/ui/Card";
import { ChevronRight, CreditCard, MonitorPlay, Zap } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import * as styles from "./ActionsPage.styles";

const ActionsPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation("actions");

  return (
    <div className={styles.container}>
      <div className={styles.headerSection}>
        <PageHeader icon={Zap} title={t("pageTitle")} />
      </div>

      <div className={styles.centerSection}>
        <div className={styles.gridContainer}>
          <Card className={styles.scrapingCard} onClick={() => navigate("/scraping")}>
            <div className={styles.iconWrapper}>
              <MonitorPlay className={styles.icon} />
            </div>
            <h2 className={styles.cardTitle}>{t("startScraping")}</h2>
            <p className={styles.cardDescription}>{t("startScrapingDesc")}</p>
            <div className={styles.actionLink}>
              <span>{t("viewLiveLogs")}</span>
              <ChevronRight className={styles.iconSmall} />
            </div>
          </Card>

          <Card className={styles.paymentCard} onClick={() => navigate("/payment")}>
            <div className={styles.iconWrapperGreen}>
              <CreditCard className={styles.iconGreen} />
            </div>
            <h2 className={styles.cardTitle}>{t("processPayments")}</h2>
            <p className={styles.cardDescription}>{t("processPaymentsDesc")}</p>
            <div className={styles.actionLinkGreen}>
              <span>{t("viewPendingInvoices")}</span>
              <ChevronRight className={styles.iconSmall} />
            </div>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default ActionsPage;
